"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../01_atoms/Icon"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _PassengerSelectionWidget = _interopRequireDefault(require("../../02_molecules/PassengerSelectionWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PassengersSelectionUI = function PassengersSelectionUI(_ref) {
  var sdk = _ref.sdk,
      _ref$numberOfPassenge = _ref.numberOfPassengers,
      numberOfPassengers = _ref$numberOfPassenge === void 0 ? 0 : _ref$numberOfPassenge,
      _ref$savedPassengers = _ref.savedPassengers,
      savedPassengers = _ref$savedPassengers === void 0 ? [] : _ref$savedPassengers,
      _ref$selectedPassenge = _ref.selectedPassengers,
      selectedPassengers = _ref$selectedPassenge === void 0 ? [] : _ref$selectedPassenge,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      _ref$onPassengerToggl = _ref.onPassengerToggle,
      onPassengerToggle = _ref$onPassengerToggl === void 0 ? function () {} : _ref$onPassengerToggl,
      _ref$onAddPassenger = _ref.onAddPassenger,
      onAddPassenger = _ref$onAddPassenger === void 0 ? function () {} : _ref$onAddPassenger,
      _ref$onConfirm = _ref.onConfirm,
      onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm;
  var translatorForNamespace = sdk.i18n.translatorForNamespace;
  var t = translatorForNamespace('PassengersSelectionUI');
  var title = t('Passengers in this trip');

  var subtitle = /*#__PURE__*/_react["default"].createElement("span", null, t('We need to know the names of the passengers on this trip'), /*#__PURE__*/_react["default"].createElement("br", null), t('Please insert their details below'));

  if (savedPassengers.length > 0) {
    subtitle = /*#__PURE__*/_react["default"].createElement("span", null, t('Use this screen to indicate who will be on this trip.'), /*#__PURE__*/_react["default"].createElement("br", null), t('{XofY} passengers confirmed', {
      XofY: "".concat(selectedPassengers.length, "/").concat(numberOfPassengers)
    }));
  }

  var topBarRightChildren = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline-flex',
      marginRight: 10
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(selectedPassengers.length, "/").concat(numberOfPassengers)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: {
      marginLeft: 10
    },
    name: "user"
  }));

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Select passengers'),
    onBack: onBack,
    topBarRightChildren: topBarRightChildren
  }, /*#__PURE__*/_react["default"].createElement(_PassengerSelectionWidget["default"], {
    title: title,
    subtitle: subtitle,
    translatorForNamespace: translatorForNamespace,
    savedPassengers: savedPassengers,
    selectedPassengers: selectedPassengers,
    numberOfPassengers: numberOfPassengers,
    onPassengerToggle: onPassengerToggle,
    onAddPassenger: onAddPassenger,
    onConfirm: onConfirm,
    translator: t
  }));
};

var _default = PassengersSelectionUI;
exports["default"] = _default;